export default __webpack_public_path__ + "static/media/mpk_3.c24d1932.png";